import { getWorkspaceSession as getSession } from "../utils/domain/workspace.js";
import { load, save } from "../utils/domain/model.js";
import { STORAGE_KEY, seed } from "../data/catalogue.js";
export const state = {};
state.refresh = () => {};
state.periodDraft = null;
state.tableStates = new Map();
state.formBaseline = null;
state.navigationApproved = false;
state.db = undefined;
state.loadError = "";
state.storageError = "";
state.activeAccount = getSession(localStorage, sessionStorage);
state.signedIn = !!state.activeAccount;
state.authBusy = false;
state.authMessage = "";
state.authEmail = "";
state.authErrors = {};
state.returnRoute = null;
state.couponDraft = null;
state.couponSearch = "";
state.lastProductOptions = [];
state.current = {
  route: "dashboard",
  id: null,
};
state.query = "";
state.filter = "All";
state.toast = "";
state.toastTimer = undefined;
state.dialog = null;
state.draft = null;
state.draftKey = "";
state.quote = null;
state.orderDraft = null;
state.profileDraft = null;
state.collectionDraft = null;
try {
  state.db = load(localStorage);
  if (localStorage.getItem(STORAGE_KEY)) {
    try {
      save(localStorage, state.db);
    } catch {
      state.storageError =
        "The update could not be saved. Your previous records remain intact; storage may be full.";
    }
  }
} catch (e) {
  state.loadError = e.message;
  state.db = seed();
}
